import { render, staticRenderFns } from "./BuchVerlagsVerkaeufe.vue?vue&type=template&id=6781bdd1&scoped=true&"
import script from "./BuchVerlagsVerkaeufe.vue?vue&type=script&lang=ts&"
export * from "./BuchVerlagsVerkaeufe.vue?vue&type=script&lang=ts&"
import style0 from "./BuchVerlagsVerkaeufe.vue?vue&type=style&index=0&id=6781bdd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6781bdd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VChip,VContainer,VDataTable,VIcon,VProgressCircular,VSelect,VSpacer,VTextField})
